import type { InvitationPayload } from '@/store/types/InvitationPayload'
import type { MembershipRole } from '@/store/types/MembershipRole'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages, parseError } from '@/backend/error'
import { put } from '@/backend/api'
import type { ApiResult } from '@/backend/darwin/types'

/**
 * Update a team membership
 */
export const updateTeamMembership = async (
  membershipId: number,
  role: MembershipRole,
): Promise<ApiResult<InvitationPayload>> => {
  let response

  try {
    response = await put<InvitationPayload>(`memberships/${membershipId}`, { role })
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.TEAM_MEMBERS_UPDATE_MEMBERSHIP, { role }),
      ok: false,
    }
  }

  return { data: response.data, ok: true }
}
